import React from "react";
import { Wrapper } from "./style";

const QuestionFormCheckbox = (props: any) => {
  return <Wrapper {...props} />;
};

export default QuestionFormCheckbox;
